import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const MusicPlayer = style({
    visibility: 'visible',
    position: 'fixed',
    maxWidth: 480,
    width: '100%',
    bottom: 90,
    zIndex: 99
})

export const MusicPlayerWrap = style({
    position: 'absolute',
    right: 15,
    bottom: 0,
    cursor: 'pointer',
    $nest: {}
})

export const playerCore = style({
    ...csstips.flexRoot,
    ...csstips.center,
    background: '#fff',
    boxShadow: '0 3px 8px 0 rgba(0,0,0,0.15)',
    borderRadius: 10,
    padding: 5,
    overflow: 'hidden'
})

export const defaultHiddenStatus = style({
    visibility: 'hidden',
    zIndex: -100
})

export const playerCoreBg = style({
    height: 40,
    width: 40,
    borderRadius: 6,
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    zIndex: 2,
    position: 'relative'
})

export const checkLecture = style({
    marginRight: '-86px',
    $nest: {
        button: {
            padding: 11,
            marginRight: 5,
            borderRadius: 6,
            fontSize: 16,
            color: '#fff',
            outline: 'none',
            border: 'none',
            cursor: 'pointer',
            background: '#FF5A31',
            $nest: {
                '&:active': {
                    background: '#f05d39'
                }
            }
        }
    }
})

export const playCoverWrap = style({
    position: 'relative',
    $nest: {
        span: {
            display: 'block',
            position: 'absolute',
            width: 40,
            height: 40,
            left: 0,
            top: 0,
            background: 'rgba(0,0,0,0.25)',
            borderRadius: 6,
            zIndex: 3
        }
    }
})

export const closeBtn = style({
    width: 20,
    height: 20,
    marginRight: 10,
    marginLeft: 5,
    $nest: {
        img: {
            cursor: 'pointer'
        }
    }
})

const rotating = keyframes({
    from : {transform: 'rotate(0)'},
    to : {transform: 'rotate(360deg)'}
})

export const loadingStatus = style({
    animationName: rotating,
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear'
})

const showButtonMove = keyframes({
    from : {marginRight: '-86px'},
    to : {marginRight: 0}
})

export const showButtonMoveTrack = style({
    '-webkit-backface-visibility': 'hidden',
    'animationName': showButtonMove,
    'animationDuration': '280ms',
    'animationIterationCount': 1,
    'animationTimingFunction': 'cubic-bezier(0.4, 0, 0.2, 1)',
    'animationFillMode': 'forwards'
})

export const emptyBlock = style({
    position: 'absolute',
    top: 0,
    width: 50,
    height: 50,
    background: '#fff',
    zIndex: 1,
    borderRadius: 6,
    overflow: 'hidden',
    right: 0
})



// WEBPACK FOOTER //
// ./src/plugins/MusicPlayer/MusicPlayer.style.ts